import { useState, useEffect, useRef } from "react";
import { RpaServices } from "../services/RpaServices";
import { CircularProgress } from "@mui/material";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CustomPagination from "../utils/paginationUtils";

import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import ShowErrorLogDetails from "./ShowErrorLogDetails";
const RpaErrorLogs = () => {
  const [loading, setLoading] = useState(false);
  const [rpaErrorReport, setRpaErrorReport] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showLogDetails, setShowLogDetails] = useState(false);

  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [fromDate, setFromDate] = useState(prevDate); // one day before date
  const [toDate, setToDate] = useState(new Date()); //current date
  const limit = 10;
  const searchTimeRef = useRef();
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getErrorReport = async () => {
    setLoading(true);
    try {
      const res = await RpaServices.getRpaErrorReport(fromDate, toDate);

      setRpaErrorReport(res?.data?.errorLogReport);
      const resReport = res?.data?.errorLogReport;
      let report = [];
      for (let key in resReport) {
        for (let codeKey in resReport[key]) {
          if (!isNaN(codeKey)) {
            report.push({
              applicationId: key,
              errorCode: codeKey,
              count: resReport[key][codeKey]?.count,
              errorReason: resReport[key][codeKey]?.errorReason,
              ownerName: resReport[key]?.applicationDetail?.ownerName,
            });
          }
        }
      }
      setRpaErrorReport(report);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getErrorReport();
  }, [page, searchKey, fromDate, toDate]);
  console.log("error report:", rpaErrorReport);

  return (
    <div className="initiateadmission-box">
      {" "}
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/ &nbsp;
        Dashboard &nbsp;/ &nbsp; RPA Error Logs
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">RPA Error Logs</div>
        {/* <div
          style={{ border: "1px solid #E4E4E4" }}
          className="flex gap-2 px-2 py-2 rounded-[8px] "
        >
          <SearchIcon />
          <input
            type="text"
            className="outline-none border-0"
            placeholder="Search Anything"
            onChange={handleSearch}
          />
        </div> */}
      </div>
      <div className="flex gap-3 items-center">
        <div>
          <label htmlFor="start-date">From Date:</label>
          <input
            type="date"
            id="from-date"
            value={formatDate(fromDate)}
            onChange={(e) => setFromDate(new Date(e.target.value))}
            max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>

        <div>
          <label htmlFor="end-date">To Date:</label>
          <input
            type="date"
            id="to-date"
            value={formatDate(toDate)}
            onChange={(e) => {
              setToDate(new Date(e.target.value));
            }}
            max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>
      </div>
      <hr style={{ color: "#E7E7E7", marginBottom: "20px" }} />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-6  text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Application ID
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Owner Name
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Error Code
              </div>{" "}
            </div>
            <div className="col-span-2">
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Error Reason
              </div>{" "}
            </div>

            <div>
              <div className="text-center text-[#191919] font-semibold mb-4">
                {" "}
                Count
              </div>
            </div>
          </div>
          {rpaErrorReport && rpaErrorReport.length > 0 ? (
            rpaErrorReport?.map((error, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div
                    className={`grid grid-cols-6  text-[#797979] text-[18px] `}
                  >
                    <div>
                      <div>{error?.applicationId || "--"}</div>
                    </div>
                    <div>
                      <div>{error?.ownerName || "--"}</div>
                    </div>
                    <div>
                      <div>{error?.errorCode || "--"}</div>
                    </div>
                    <div className="col-span-2">
                      <div>{error?.errorReason || "--"}</div>
                    </div>

                    <div>
                      <div
                        className="text-center text-blue-500 cursor-pointer"
                        onClick={() => {
                          setSelectedApplication({
                            applicationId: error.applicationId,
                            errorCode: error.errorCode,
                          });
                          setShowLogDetails(true);
                        }}
                      >
                        {error?.count || "--"}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
              No Error Logs Found
            </div>
          )}
        </div>
      )}
      {showLogDetails && (
        <ShowErrorLogDetails
          setOpen={setShowLogDetails}
          selectedApplication={selectedApplication}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
      {/* <div className="mt-5 flex justify-center">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
        
      </div> */}
    </div>
  );
};

export default RpaErrorLogs;
